/**
 *
 * @param query - substring to match against each item
 * @param items - Array of items
 */
export function computeClikArtResultsJS(
  query: string,
  items: Array<{ name: string }>
): Array<{ name: string }> {
  if (!query.trim()) return items
  const loweredQuery = query.toLowerCase()

  return items.filter((item) => item.name.toLowerCase().includes(loweredQuery))
}
